import { LOADING } from "../../Actions/Types";
import { addAdminSubUser, getAdminSubUsers } from "../../Api/AdminManagementAPI";
import { getUserActivityListApi, postUserActivityListApi } from "../../Api/UserActivity";

// service to get domain list with details
const getAdminSubUserListService = (
    token: string, // access token
    dispatch: Function, // dispatch function to store redux data
    t: Function, // i18next t function
    setUserActivityList: Function, // function to set domain list
    limit: number, // limit per page
    offset: number, // page offset
    setTotalRecord: Function,  // function to set displayed record count
    currentPage:number
) => {

    // Set Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // API to get domain list
    getAdminSubUsers(token).then((res) => {
        // check if response is ok
        if (res.status === 200) {

            const indexOfLastItem = currentPage * limit;
            const indexOfFirstItem = indexOfLastItem - limit;

            const updateResData = res.data.slice(indexOfFirstItem, indexOfLastItem);
            
            setUserActivityList(updateResData);
            // Set Record Record
            setTotalRecord(res.data.length);

            // Set Loading
            dispatch({
                type: LOADING,
                payload: false,
            });
        }
    })
}

// service to get domain list with details
const postAdminListService = (
    token: string, // access token
    title : any, // start date filter
    description : string, // end date filter
) => {

    // API to get domain list
    addAdminSubUser(token, title).then((res) => {
        // check if response is ok
        if (res.status === 200) {
            // Set Loading
            return res.Data
        }
    })
}

export { getAdminSubUserListService, postAdminListService }